// Etiket baskısında yazıcının yatay kaymasını telafi eder (sadece etiketler, fişleri etkilemez).
// Ofset tasarımın settings.printOffsetX alanında mm cinsinden tutulur (negatif = sola).
// Her öğe ofset kadar kaydırılır; ancak görünen içeriği (metin/barkod) etiketin sol kenarından
// taşacaksa sadece kenara kadar kaydırılır — böylece barkodun başı kesilip okunmaz hale gelmez.

export const LABEL_EL_CLASS = 'lbl-el';

// Barkod çizgi (modül) kalınlığı, mm. Barkod kutuya sığsın diye esnetilmez; bu kalınlıkla
// doğal genişliğinde basılıp kutusunda ortalanır. Sadece kutudan büyükse kutuya sığacak kadar daraltılır.
export const DEFAULT_BARCODE_MODULE_MM = 0.21;

export const getBarcodeModuleMm = (design) => {
  const v = parseFloat(design?.settings?.barcodeModuleMm);
  return Number.isFinite(v) && v > 0 ? v : DEFAULT_BARCODE_MODULE_MM;
};

// JsBarcode çalıştıktan sonra çağrılacak applyBarcodeSize() fonksiyonu.
// jsBarcodeWidth: JsBarcode'a verilen width (1 modül = jsBarcodeWidth px).
// Çizgi birimi yazıcının tam nokta sayısına yuvarlanır (203dpi'de 0.21mm → 2 nokta = 0.25mm):
// kesirli birimde (1.65 nokta) yazıcı aynı çizgiyi bazen 1 bazen 2 nokta basıp oranları bozuyor,
// yanlış okumaya yol açıyordu. Tam noktada kutuya sığmayan barkodlar (27'li 10 haneliler)
// eskisi gibi moduleMm ile basılır (1 noktaya inmek yanlış okuma yaptı, 2026-10-27).
export const labelBarcodeSizeScript = (moduleMm, jsBarcodeWidth, dpi) => `
function applyBarcodeSize() {
  var dotMm = 25.4 / ${parseInt(dpi, 10) || 203};
  var moduleMm = ${Number(moduleMm)};
  var snappedMm = Math.max(1, Math.round(moduleMm / dotMm)) * dotMm;
  document.querySelectorAll('svg.barcode-svg').forEach(function(svg) {
    var w = parseFloat(svg.getAttribute('width'));
    if (!w) return;
    var modules = w / ${Number(jsBarcodeWidth) || 1};
    // Kutunun etiket içinde kalan kısmı (kutu kenardan taşıyorsa ortalı barkodun iki yanı da o kadar daralır)
    var box = 0;
    if (svg.parentElement) {
      var br = svg.parentElement.getBoundingClientRect();
      var label = svg.closest('.label-container');
      var lr = label ? label.getBoundingClientRect() : br;
      var cut = Math.max(0, lr.left - br.left, br.right - lr.right);
      box = Math.max(0, br.width - 2 * cut) * 25.4 / 96;
    }
    var widthMm = (!box || modules * snappedMm <= box + 0.01) ? modules * snappedMm : modules * moduleMm;
    svg.setAttribute('preserveAspectRatio', 'none');
    svg.style.width = widthMm.toFixed(3) + 'mm';
    svg.style.maxWidth = '100%';
    svg.style.flexShrink = '0';
    // Barkodun başı/sonu etiketin kenarından taşıyorsa (sol bölüm baskıda sola kaydırılıyor) içeri it:
    // kesilen başlangıç/bitiş çizgileriyle barkod hiç okunmuyordu (27'li 10 haneliler).
    svg.style.transform = '';
    var lbl = svg.closest('.label-container');
    if (lbl) {
      var sr = svg.getBoundingClientRect(), lr2 = lbl.getBoundingClientRect();
      var push = sr.left < lr2.left ? lr2.left - sr.left : (sr.right > lr2.right ? lr2.right - sr.right : 0);
      if (push) svg.style.transform = 'translateX(' + push.toFixed(2) + 'px)';
    }
  });
}`;

export const getLabelPrintOffset = (design) => {
  const v = parseFloat(design?.settings?.printOffsetX);
  return Number.isFinite(v) ? v : 0;
};

// Yazdırma sayfasına eklenecek script gövdesi. Barkodlar oluşturulduktan sonra çağrılmalı.
export const labelShiftScript = (offsetMm) => {
  if (!offsetMm) return 'function applyLabelShift() {}';
  return `
function applyLabelShift() {
  var offsetPx = ${Number(offsetMm)} * 96 / 25.4;
  document.querySelectorAll('.label-container').forEach(function(container) {
    var cLeft = container.getBoundingClientRect().left;
    container.querySelectorAll('.${LABEL_EL_CLASS}').forEach(function(el) {
      el.style.transform = '';
      var box = el.getBoundingClientRect();
      var content = el.querySelector('svg, span');
      var cr = box;
      if (content) {
        if (content.tagName.toLowerCase() === 'span') {
          var range = document.createRange();
          range.selectNodeContents(content);
          cr = range.getBoundingClientRect();
        } else {
          cr = content.getBoundingClientRect();
        }
        if (!cr.width) cr = box;
      }
      var visibleLeft = Math.max(cr.left, box.left) - cLeft;
      var shift = offsetPx;
      if (shift < 0) shift = Math.max(shift, -Math.max(visibleLeft, 0));
      el.style.transform = 'translateX(' + shift.toFixed(2) + 'px)';
    });
  });
}`;
};

// Chrome PDF/yazdırma sayfa boyutunu 0.01 inç'e yukarı yuvarlıyor (9mm → 0.36in = 9.144mm):
// her etikette fazladan kağıt sürülür, toplu baskıda kayma birikir. Sayfa yüksekliğini tam
// temsil edilebilen, etiketi aşmayan en yakın 0.01 inç değeriyle veririz (9mm → 0.35in = 8.89mm).
export const labelPageHeightIn = (mm) => (Math.floor((Number(mm) || 0) / 25.4 * 100 + 1e-6) / 100).toFixed(2);

// Toplu baskıda birikmeli dikey kayma için deneme-yanılma ayarları (tüm taslaklar, sadece HTML/sürücü yolu
// için sayfa boyu; dikey kaydırma Zebra yolunda da uygulanır):
// labelPageAdjustMm: her etiketin sayfa boyuna eklenir (+ = etiketler gittikçe yukarı kayıyorsa).
//   Chrome 0.01 inç (0.254mm) adımla uyguladığı için ~0.25mm'lik adımlarla artırılmalı.
// printOffsetY: tüm öğeleri aşağı (+) / yukarı (−) kaydırır, mm.
const settingMm = (design, key) => {
  const v = parseFloat(design?.settings?.[key]);
  return Number.isFinite(v) ? v : 0;
};
export const getLabelPageAdjustMm = (design) => settingMm(design, 'labelPageAdjustMm');
export const getLabelPrintOffsetY = (design) => settingMm(design, 'printOffsetY');
export const getLabelPageHeightIn = (design) =>
  labelPageHeightIn((parseFloat(design?.dimensions?.labelHeight) || 0) + getLabelPageAdjustMm(design));
// Yazdırma sayfasına eklenecek öğe CSS'i:
// - contain:strict → öğe bölünemez kutu olur. Yoksa sayfa sınırını aşan öğeyi (ör. aşağı kaydırılmış
//   alt satır) Chrome bir sonraki sayfaya atıp gizliyor; toplu baskıda son etiket hariç hepsinde
//   barkod numarası/kategori kayboluyordu.
// - margin-top → dikey kaydırma (absolute öğede margin-top = kayma).
export const labelElementCss = (design) => {
  const y = getLabelPrintOffsetY(design);
  return `.${LABEL_EL_CLASS} { contain: strict;${y ? ` margin-top: ${y}mm;` : ''} }`;
};

// Etiketin 4 baskı bölgesi soldan sağa bu sırayla dizili (Sol | Kat | Bilgi | Kuyruk).
// Tasarım ekranı, HTML baskı ve Zebra (ZPL) baskısı öğe konumunu bu tek fonksiyondan alır.
export const LABEL_AREA_KEYS = ['left', 'fold', 'info', 'tail'];
export const LABEL_AREA_DIM_KEY = { left: 'leftPrintAreaWidth', fold: 'foldAreaWidth', info: 'infoPrintAreaWidth', tail: 'tailAreaWidth' };
export const getLabelAreaOffset = (area, dm) => {
  const target = LABEL_AREA_KEYS.includes(area) ? area : 'left';
  let offset = 0;
  for (const key of LABEL_AREA_KEYS) {
    if (key === target) break;
    offset += parseFloat(dm?.[LABEL_AREA_DIM_KEY[key]]) || 0;
  }
  return offset;
};

// Baskıda bölüm bazlı sabit yatay düzeltme (mm, eksi = sola). Fiziksel etikette sol bölüm
// tasarımdakine göre sağa kayık basılıyordu (mağazada ölçüldü, 2026-10-27); tasarım ekranında öğeler
// olduğu gibi (ortada) görünür, sadece yazıcıya giden çıktıda (HTML + Zebra) uygulanır.
// Sadece gümüş tasarımları: altın etiketler zaten doğru basılıyordu, kaydırınca sola kaçtı.
const LABEL_AREA_PRINT_SHIFT_MM = { silver: { left: -1.5 } };
export const getLabelAreaPrintOffset = (area, design) => {
  const target = LABEL_AREA_KEYS.includes(area) ? area : 'left';
  const shift = LABEL_AREA_PRINT_SHIFT_MM[design?.type]?.[target] || 0;
  return getLabelAreaOffset(area, design?.dimensions) + shift;
};

// Öğenin kutusu içindeki yatay hizası (metin ve barkod için aynı alan: textAlign)
export const getLabelAlign = (el) => (el?.textAlign === 'left' || el?.textAlign === 'right' ? el.textAlign : 'center');
export const labelAlignJustify = (el) => ({ left: 'flex-start', right: 'flex-end', center: 'center' }[getLabelAlign(el)]);

// ---- Barkod formatı ----
// Tüm barkodlar Code128 (düz, hepsi aynı yükseklikte). EAN (uzun kılavuz çizgili) denendi, karışık
// görünüm istenmedi: 8 haneliler EAN, 27'li 10 haneliler Code128 çıkıyordu (2026-11-02).
export const getLabelBarcodeFormat = () => 'CODE128';

// JsBarcode seçenekleri. moduleWidth: 1 modül kaç birim (px/nokta), heightUnits: toplam yükseklik.
// EAN'da kılavuz çizgileri tam yükseklik, veri çizgileri ~%85 (JsBarcode kılavuzu height + fontSize/2 çizer).
export const labelBarcodeOptions = (value, design, moduleWidth, heightUnits) => {
  const format = getLabelBarcodeFormat(value, design);
  const total = Math.max(2, Math.round(heightUnits));
  const base = { format, width: moduleWidth, displayValue: false, margin: 0, background: '#ffffff', lineColor: '#000000' };
  if (format === 'CODE128') return { ...base, height: total };
  const guard = Math.max(1, Math.min(Math.round(total * 0.15), moduleWidth * 5));
  return { ...base, height: total - guard, fontSize: guard * 2, textMargin: 0 };
};
